import {MyopMessages} from "../../common/MyopMessages";
import {SetAttributeMessage} from "../../messages";
import {BaseMessageHandler} from "../../common";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class setAttributeHandler extends BaseMessageHandler<SetAttributeMessage> {

    messageType = MyopMessages.SetAttributeMessage;

    executor = (event: SetAttributeMessage) => {
        const items = getElementsByRef(event.ref, document);
        items.forEach(item => {
            item.setAttribute(event.name, event.value)
        })
    }
}
